<div class="ml-2">
    <bpt-search
    *ngIf="isScopeLookup"
      class="search-component"
      [placeholder]="placeHolder"
      [errorText]="errorText"
      [advancedSearch]="true"
      [searchControls]="searchControl"
      [search]="getSearchResults"
      [advancedSearchMethod]="getAdvancedSearchResults"
    >
    </bpt-search>
  </div>
  <div *ngIf="trainingItemGroups!=undefined && trainingItemGroups.length > 0 && isSearch && !spinnerOn">
    <app-training-item-group-panel-list #trainingItemGroupPanel [trainingItemGroupResult]="trainingItemGroups" (selectedItems)="linkedItemsSelectedData($event)" ></app-training-item-group-panel-list>
  </div>
  <div class = "displayCenter" *ngIf="(trainingItemGroups==undefined || trainingItemGroups.length == 0) && isSearch && !spinnerOn">
    <app-empty-results></app-empty-results>  
  </div>
